<template>
    <div id="storyList" :class="{ akinon: akinonEnabled }" @paste="handlePaste">
        <div class="content">
            <div class="multi-delete-bar" v-if="multiDeleteMode">
                <section class="uncheck" @click="resetSelectedStories">
                    <span class="material-icons"> arrow_back </span>
                    {{ $t("chatbotv2.uncheckAll") }}
                </section>
                <section class="select" @click="selectAllStories">{{ $t("chatbotv2.selectAll") }}</section>

                <section class="queries">
                    {{ $t("chatbotv2.selectedStory", { count: selectedStories.length }) }}
                </section>
                <section class="actions">
                    <div
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="$t('chatbotv2.delete')"
                        @click="showDeleteConfirmation()"
                    >
                        <span class="material-icons"> delete </span>
                    </div>
                    <div
                        class="actions"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="$t('message.cancel')"
                        @click="resetSelectedStories"
                    >
                        <span class="material-icons"> close </span>
                    </div>
                </section>
            </div>
            <div v-if="!modalVisible">
                <div class="big-title-container">
                    <div class="big-title">{{ $t("chatbotv2.allSecnario") }}</div>
                    <div class="search-and-filters">
                        <a-input-search
                            v-model="searchQuery"
                            :placeholder="$t('message.search')"
                            style="width: 250px"
                            @change="handleSearch"
                        />
                        <a-button-group class="platform-filters">
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('web') }"
                                @click="togglePlatform('web')"
                                :content="'Web'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <SupsisIcon style="width: 16px; height: 16px" />
                            </a-button>
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('telegram') }"
                                @click="togglePlatform('telegram')"
                                :content="'Telegram (BotFather)'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <TelegramIcon style="width: 16px; height: 16px" />
                            </a-button>
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('whatsapp') }"
                                @click="togglePlatform('whatsapp')"
                                :content="'Whatsapp QR Kanalları'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <WhatsappIcon
                                    style="width: 16px; height: 16px"
                                    :specialBackgroundMode="true"
                                    color="#28AC01"
                                />
                            </a-button>
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('whatsapp-business-api') }"
                                @click="togglePlatform('whatsapp-business-api')"
                                :content="'Whatsapp Business API'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <WhatsappBusinessIcon
                                    style="width: 16px; height: 16px"
                                    :specialBackgroundMode="true"
                                    color="#28AC01"
                                />
                            </a-button>
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('messenger') }"
                                @click="togglePlatform('messenger')"
                                :content="'Messenger'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <MessengerIcon style="width: 16px; height: 16px" />
                            </a-button>
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('instagram') }"
                                @click="togglePlatform('instagram')"
                            >
                                <InstagramIcon
                                    style="width: 16px; height: 16px"
                                    :specialBackgroundMode="true"
                                    color="#28AC01"
                                />
                            </a-button>
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('linkedin') }"
                                @click="togglePlatform('linkedin')"
                                :content="'Linkedin'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <LinkedinIcon style="width: 16px; height: 16px" />
                            </a-button>
                             <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('telegram-qr') }"
                                @click="togglePlatform('telegram-qr')"
                                :content="'Telegram QR'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <TelegramIcon style="width: 16px; height: 16px" />
                            </a-button>
                            <a-button
                                class="platform-button integration-icons"
                                :class="{ active: selectedPlatforms.includes('trendyol') }"
                                @click="togglePlatform('trendyol')"
                                :content="'Trendyol'"
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                            >
                                <TrendyolIcon style="width: 16px; height: 16px" />
                            </a-button>
                        </a-button-group>
                    </div>
                </div>
                <div class="stories">
                    <div
                        class="story story-add"
                        md="3"
                        @click="() => (modalVisible = true)"
                        v-if="checkPermission(PERMISSION_TYPES['chatbot.stories.create'].tr.name)"
                    >
                        <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                        <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">{{
                            $t("chatbotv2.addBot")
                        }}</span>
                    </div>
                    <div v-if="loading" style="display: flex">
                        <div
                            v-for="skltn in 3"
                            class="story story-add mx-2 p-3"
                            :key="skltn"
                            md="3"
                            style="background: white !important"
                        >
                            <a-skeleton :active="true" :paragraph="{ rows: 3 }" />
                        </div>
                    </div>

                    <a
                        v-else
                        class="story"
                        :class="{ selected: isStorySelected(story.id) }"
                        v-for="story in displayedStories"
                        :key="story.id"
                        md="3"
                        :href="getStoryHref(story)"
                        @click="handleStoryClick(story, $event)"
                    >
                        <div
                            class="transparent-area"
                            v-if="multiDeleteMode"
                            @click.stop="addSelectedStories(story.id)"
                        ></div>
                        <span v-if="multiDeleteMode">
                            <input
                                type="checkbox"
                                :id="`checkbox-${story.id}`"
                                v-model="selectedStories"
                                :value="story.id"
                                class="custom-checkbox-multi-delete"
                                @click.stop
                            />
                            <label :for="`checkbox-${story.id}`" class="custom-label-multi-delete" @click.stop></label>
                        </span>
                        <div
                            class="ribbon w-100 m-2 text-dark"
                            v-if="
                                isForwardedToWeb(story) ||
                                isForwardedToWhatsapp(story.id) ||
                                isForwardedToWhatsappApi(story.id) ||
                                isForwardedToInstagram(story.id) ||
                                isForwardedToMessenger(story.id) ||
                                isForwardedToTrendyol(story.id) ||
                                isForwardedToLinkedin(story.id) ||
                                isForwardedToTelegramQR(story.id)
                            "
                            @click="
                                (e) => {
                                    e.stopPropagation();
                                }
                            "
                        >
                            <span>
                                <span>{{ $t("chatbotv2.integratedWith") }}</span>
                                <span>
                                    <span v-for="(item, index) in getKeysOfIntegrations(story)">
                                        <SupsisIcon
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Supsis Widget'"
                                            class="integration-icons pt-2"
                                            v-if="item === 'supsisWidget' && isForwardedToWeb(story)"
                                        />
                                        <TelegramIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Telegram'"
                                            class="integration-icons pt-2"
                                            v-if="item === 'telegram' && getValueOfIntegrations(story)[index] === true"
                                        />
                                        <FacebookIcon
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Facebook'"
                                            class="integration-icons pt-2"
                                            v-if="item === 'facebook' && getValueOfIntegrations(story)[index] === true"
                                        />
                                        <TwitterIcon
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Twitter'"
                                            class="integration-icons pt-2"
                                            v-if="item === 'twitter' && getValueOfIntegrations(story)[index] === true"
                                        />
                                        <SlackIcon
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Slack'"
                                            class="integration-icons pt-2"
                                            v-if="item === 'slack' && getValueOfIntegrations(story)[index] === true"
                                        />
                                        <SkypeIcon
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Skype'"
                                            class="integration-icons pt-2"
                                            v-if="item === 'skype' && getValueOfIntegrations(story)[index] === true"
                                        />
                                        <ShopifyIcon
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Shopify'"
                                            class="integration-icons pt-2"
                                            v-if="item === 'shopify' && getValueOfIntegrations(story)[index] === true"
                                        />
                                    </span>
                                    <span>
                                        <WhatsappIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Whatsapp'"
                                            :color="'#28AC01'"
                                            class="integration-icons pt-2"
                                            v-if="isForwardedToWhatsapp(story.id)"
                                        />
                                        <WhatsappBusinessIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Whatsapp Business API'"
                                            :color="'#28AC01'"
                                            class="integration-icons pt-2"
                                            v-if="isForwardedToWhatsappApi(story.id)"
                                        />
                                        <InstagramIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Instagram'"
                                            class="integration-icons pt-2"
                                            v-if="isForwardedToInstagram(story.id)"
                                        />
                                        <MessengerIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Messenger'"
                                            class="integration-icons pt-2"
                                            v-if="isForwardedToMessenger(story.id)"
                                        />
                                        <LinkedinIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Linkedin'"
                                            class="integration-icons pt-2"
                                            v-if="isForwardedToLinkedin(story.id)"
                                        />
                                        <TelegramIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Telegram QR'"
                                            class="integration-icons pt-2"
                                            v-if="isForwardedToTelegramQR(story.id)"
                                        />
                                        <TrendyolIcon
                                            :specialBackgroundMode="true"
                                            v-tippy="{ followCursor: true, placement: 'top-center' }"
                                            :content="'Trendyol'"
                                            class="integration-icons pt-2"
                                            v-if="isForwardedToTrendyol(story.id)"
                                        />
                                    </span>
                                </span>
                            </span>
                        </div>
                        <a-popover id="story-menu-popover" trigger="click" class="story-menu-content px-3">
                            <div slot="content">
                                <div
                                    class="story-menu-popover-items"
                                    @click="$router.push(`/chatbot/story/${story.id}/${getDraftVersion(story)}`)"
                                >
                                    <span> <a-icon type="edit" class="px-1" /></span>
                                    <span slot="content">{{ $t("message.edit") }}</span>
                                </div>
                                <hr style="margin-bottom: 0.2rem; margin-top: 0.2rem" />
                                <div class="story-menu-popover-items" @click="duplicateAStory(story)">
                                    <span> <a-icon type="switcher" class="px-1" /></span>
                                    <span slot="content">{{ $t("message.duplicate") }}</span>
                                </div>
                                <hr style="margin-bottom: 0.2rem; margin-top: 0.2rem" />
                                <div
                                    class="story-menu-popover-items"
                                    @click="multiDeleteModeOpen(story.id)"
                                    v-if="checkPermission(PERMISSION_TYPES['chatbot.stories.delete'].tr.name)"
                                >
                                    <span> <a-icon type="delete" class="px-1" /></span>
                                    <span slot="content">{{ $t("message.delete") }}</span>
                                </div>
                                <hr style="margin-bottom: 0.2rem; margin-top: 0.2rem" />
                            </div>
                            <a-button
                                class="chatbot-btn"
                                style="margin-left: auto; font-weight: bolder; letter-spacing: 2px; font-size: 20px"
                                @click="(e) => e.stopPropagation()"
                            >
                                {{ story.name }}
                                <span v-if="!multiDeleteMode">...</span>
                            </a-button>
                        </a-popover>
                        <div class="d-flex flex-column justify-content-between px-3 graph-alignment">
                            <div class="title">{{ story.title }}</div>
                            <span v-if="$_.isEmpty(story.description)">{{ story.description }}</span>
                            <div
                                v-else
                                v-tippy="{ followCursor: true, placement: 'top-center' }"
                                :content="story.description"
                                class="description text-shorten"
                            >
                                {{ story.description }}
                            </div>
                            <ECharts :option="lineBar(story.meta.last7DaysUsages)" class="echart-graph" />
                        </div>
                    </a>
                </div>

                <div
                    class="section-templates"
                    :class="{ akinon: akinonEnabled }"
                    v-if="checkPermission(PERMISSION_TYPES['chatbot.templates.view'].tr.name)"
                    v-show="!modalVisible"
                >
                    <div class="section-templates-header">
                        <div text-type="h2" text-weight="semi-bold" class="section-templates-header-text">
                            <span class="material-icons"> tips_and_updates </span>
                            {{ $t("message.useReadyTemplates") }}
                        </div>
                        <a-button type="primary" ghost @click="gotoTemplatePage"
                            >{{ $t("message.checkMore") }}
                        </a-button>
                    </div>
                    <Templates
                        :show-search="false"
                        :show-side-bar="false"
                        :enabled-slugs="
                            akinonEnabled
                                ? ['us-polo-assn', 'pierre-cardin', 'cacharel']
                                : ['online-quiz-bot', 'call-scheduling', 'university-bot']
                        "
                        :page-mode="false"
                    />
                </div>
                <!--                <div-->
                <!--                    class="section-templates"-->
                <!--                    v-if="checkPermission(PERMISSION_TYPES['chatbot.aitemplates.view'].tr.name) && !modalVisible"-->
                <!--                >-->
                <!--                    <div class="section-templates-header">-->
                <!--                        <div text-type="h2" text-weight="semi-bold" class="section-templates-header-text">-->
                <!--                            <img src="/static/img/chatbot/genie.svg" style="width: 30px; height: 30px" />-->
                <!--                            {{ $t("message.useAITemplates") }}-->
                <!--                        </div>-->
                <!--                        <a-button type="primary" ghost @click="gotoAITemplatePage"-->
                <!--                            >{{ $t("message.checkMore") }}-->
                <!--                        </a-button>-->
                <!--                    </div>-->
                <!--                    <AITemplates-->
                <!--                        :show-search="false"-->
                <!--                        :show-side-bar="false"-->
                <!--                        :enabled-slugs="[-->
                <!--                            'gpt3-english-translator',-->
                <!--                            'gpt3-it-expert',-->
                <!--                            'gpt3-Football-Commentator',-->
                <!--                            'gpt3-relationship-coach',-->
                <!--                        ]"-->
                <!--                        :page-mode="false"-->
                <!--                    />-->
                <!--                </div>-->
            </div>

            <CreateChatbot v-if="modalVisible" @close="() => (modalVisible = false)" />
        </div>
    </div>
</template>

<script>
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts";
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { log2 } from "../../../../../utils/log2";
import _ from "lodash";
import NewStoryForm from "./NewStoryForm";
import SideMenuBar from "../../SideMenuBar";
import Templates from "../templates/Templates";
import AITemplates from "../templates/AITemplates";
import moment from "moment";
import WhatsappIcon from "../integrations/svg/WhatsappIcon";
import InstagramIcon from "../integrations/svg/InstagramIcon";
import TelegramIcon from "../integrations/svg/TelegramIcon";
import FacebookIcon from "../integrations/svg/FacebookIcon";
import TwitterIcon from "../integrations/svg/TwitterIcon";
import SlackIcon from "../integrations/svg/SlackIcon";
import SkypeIcon from "../integrations/svg/SkypeIcon";
import ShopifyIcon from "../integrations/svg/ShopifyIcon";
import SupsisIcon from "../integrations/svg/SupsisIcon";
import CONFIG from "../../../../../config/config";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import CreateChatbot from "./CreateChatbot.vue";
import ChatbotMenu from "../../ChatbotMenu.vue";
import WhatsappBusinessIcon from "../integrations/svg/WhatsappBusinessIcon.vue";
import MessengerIcon from "../integrations/svg/MessengerIcon.vue";
import TrainForm from "../training/TrainForm.vue";
import TrendyolIcon from "../integrations/svg/TrendyolIcon.vue";
import LinkedinIcon from "../integrations/svg/LinkedinIcon.vue";

library.add(faSpinner);
Vue.use(plugin, { echarts });

const log = log2("StoryList");
export default {
    name: "StoryList",
    components: {
        LinkedinIcon,
        TrendyolIcon,
        TrainForm,
        ChatbotMenu,
        CreateChatbot,
        SideMenuBar,
        ECharts: createComponent({ echarts }),
        NewStoryForm,
        Templates,
        AITemplates,
        SupsisIcon,
        WhatsappIcon,
        InstagramIcon,
        TelegramIcon,
        FacebookIcon,
        TwitterIcon,
        SlackIcon,
        SkypeIcon,
        ShopifyIcon,
        WhatsappBusinessIcon,
        MessengerIcon,
    },
    data() {
        return {
            selectedStories: [],
            multiDeleteMode: false,
            visible: false,
            modalVisible: false,
            loading: true,
            integrations: [],
            akinonEnabled: CONFIG.AKINON.enabledReal,
            queryAction: this.$route.query.action,
            searchQuery: "",
            filteredStories: [],
            selectedPlatforms: [],
            cancels: [],
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            user: (state) => state.auth.user,
            stories: (state) => state.CB.stories,
            whatsappChannels: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-v1", "whatsapp-qr", "whatsapp-v2","whatsapp-unipile"].includes(x.type)),
            whatsappApiChannels: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-business-api"].includes(x.type)),
            instagramChannels: (state) => state.channel.channels.filter((x) => ["instagram"].includes(x.type)),
            messengerChannels: (state) => state.channel.channels.filter((x) => ["messenger"].includes(x.type)),
            trendyolChannels: (state) => state.channel.channels.filter((x) => ["trendyol"].includes(x.type)),
            webChatChannel: (state) => state.channel.channels.find((x) => x.type === "webchat"),
            telegramChannels: (state) => state.channel.channels.filter((x) => ["telegram-unipile"].includes(x.type)),
            linkedinChannels: (state) => state.channel.channels.filter((x) => ["linkedin-unipile"].includes(x.type)),
        }),
        displayedStories() {
            let filteredStories = this.stories;

            if (this.searchQuery) {
                filteredStories = filteredStories.filter(
                    (story) =>
                        story.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                        story.description.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            }

            if (this.selectedPlatforms.length > 0) {
                filteredStories = filteredStories.filter((story) =>
                    this.selectedPlatforms.some((platform) => {
                        if (platform === "web") return this.isForwardedToWeb(story);
                        if (platform === "telegram") return story.integrations.telegram;
                        if (platform === "whatsapp") return this.isForwardedToWhatsapp(story.id);
                        if (platform === "whatsapp-business-api") return this.isForwardedToWhatsappApi(story.id);
                        if (platform === "messenger") return this.isForwardedToMessenger(story.id);
                        if (platform === "instagram") return this.isForwardedToInstagram(story.id);
                        if (platform === "trendyol") return this.isForwardedToTrendyol(story.id);
                        if (platform === "linkedin") return this.isForwardedToLinkedin(story.id);
                        if (platform === "telegram-qr") return this.isForwardedToTelegramQR(story.id);

                    })
                );
            }

            return filteredStories;
        },
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
            deleteStory: "CB/deleteStory",
            duplicateStory: "CB/duplicateStory",
            createStoryFromDiagram: "CB/createStoryFromDiagram",
        }),
        goToStory(story) {
            if (
                this.checkPermission(PERMISSION_TYPES["chatbot.view"].tr.name) ||
                this.checkPermission(PERMISSION_TYPES["chatbot.stories.view"].tr.name)
            ) {
                this.$router.push(`/chatbot/story/${story.id}/${this.getDraftVersion(story)}`);
            } else {
                this.$message.error(this.$t("permissionErrors.chatbotStoryRead"));
            }
        },
        getStoryHref(story) {
            if (
                this.checkPermission(PERMISSION_TYPES["chatbot.view"].tr.name) ||
                this.checkPermission(PERMISSION_TYPES["chatbot.stories.view"].tr.name)
            ) {
                return `#/chatbot/story/${story.id}/${this.getDraftVersion(story)}`;
            }
            return "#";
        },
        handleStoryClick(story, event) {
            // Multi delete mode'da ise normal tıklama davranışını engelle
            if (this.multiDeleteMode) {
                event.preventDefault();
                return;
            }

            // Command/Ctrl + Click durumunda tarayıcının varsayılan davranışına izin ver
            if (event.metaKey || event.ctrlKey) {
                // Permission kontrolü yap
                if (
                    this.checkPermission(PERMISSION_TYPES["chatbot.view"].tr.name) ||
                    this.checkPermission(PERMISSION_TYPES["chatbot.stories.view"].tr.name)
                ) {
                    return; // Tarayıcının varsayılan davranışına izin ver
                } else {
                    event.preventDefault();
                    this.$message.error(this.$t("permissionErrors.chatbotStoryRead"));
                }
            } else {
                // Normal tıklama durumunda varsayılan davranışı engelle ve router kullan
                event.preventDefault();
                this.goToStory(story);
            }
        },
        isStorySelected(id) {
            return this.selectedStories.includes(id);
        },
        addSelectedStories(id) {
            if (this.selectedStories.includes(id)) {
                this.selectedStories = this.selectedStories.filter((x) => x !== id);
            } else {
                this.selectedStories.push(id);
            }
        },
        selectAllStories() {
            this.selectedStories = this.stories.map((x) => x.id);
        },
        resetSelectedStories() {
            this.selectedStories = [];
        },
        multiDeleteModeOpen(firstId) {
            this.multiDeleteMode = true;
            this.selectedStories.push(firstId);
        },
        getValueOfIntegrations(story) {
            return Object.values(_.get(story, "integrations", []) || []);
        },
        isForwardedToWeb(story) {
            return this.webChatChannel?.forward?.story === story._id;
        },
        isForwardedToWhatsapp(story) {
            const forwardStory = this.whatsappChannels.find((channel) => channel.forward?.story === story);
            return forwardStory && forwardStory.chatbotId === story.id;
        },
        isForwardedToWhatsappApi(story) {
            const forwardStory = this.whatsappApiChannels.find((channel) => channel.forward?.story === story);
            return forwardStory && forwardStory.chatbotId === story.id;
        },
        isForwardedToInstagram(story) {
            const forwardStory = this.instagramChannels.find((channel) => channel.forward?.story === story);
            return forwardStory && forwardStory.chatbotId === story.id;
        },
        isForwardedToLinkedin(story) {
            const forwardStory = this.linkedinChannels.find((channel) => channel.forward?.story === story);
            return forwardStory && forwardStory.chatbotId === story.id;
        },
        isForwardedToTelegramQR(story) {
            const forwardStory = this.telegramChannels.find((channel) => channel.forward?.story === story);
            return forwardStory && forwardStory.chatbotId === story.id;
        },
        isForwardedToTrendyol(storyId) {
            return !!this.trendyolChannels.find((channel) => channel.commentForward?.story === storyId);
        },
        isForwardedToMessenger(story) {
            const forwardStory = this.messengerChannels.find((channel) => channel.forward?.story === story);
            return forwardStory && forwardStory.chatbotId === story.id;
        },
        getKeysOfIntegrations(story) {
            return Object.keys(_.get(story, "integrations", []) || []);
        },
        gotoTemplatePage() {
            this.$router.push("/chatbot/templates");
        },
        gotoAITemplatePage() {
            this.$router.push("/chatbot/ai/templates");
        },
        deleteStories() {
            log("deleteStory");
            if (this.selectedStories && this.selectedStories.length > 0) {
                this.deleteStory(this.selectedStories).then(() => {
                    this.listStories();
                    this.resetSelectedStories();
                });
            }
        },
        duplicateAStory(story) {
            log("duplicateStory", story);
            this.duplicateStory(story._id);
        },
        getDraftVersion(story) {
            return _.get(
                story.meta.versions.find((x) => x.isDraft),
                "version",
                "1.0"
            );
        },
        lineBar(last7DaysUsages) {
            log("last7DaysUsages", last7DaysUsages);
            if (!!last7DaysUsages)
                return {
                    tooltip: {
                        trigger: "axis",
                        position: "top",
                        confine: true,
                    },
                    grid: {
                        top: 5,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    },
                    xAxis: {
                        type: "category",
                        data: last7DaysUsages.map((x) => moment(x.date).format("YYYY-MM-DD")),
                        show: false,
                    },
                    yAxis: {
                        type: "value",
                        show: false,
                        scale: true,
                    },
                    series: [
                        {
                            type: "line",
                            symbol: "none",
                            smooth: true,
                            data: last7DaysUsages.map((x) => x.count),
                        },
                    ],
                };
        },
        hide() {
            this.visible = false;
        },
        showDeleteConfirmation() {
            this.$confirm({
                title: this.$t("chatbotv2.douYouWannaDeleteItem"),
                onOk: () => {
                    this.deleteStories();
                },
                onCancel() {},
            });
        },
        handlePaste(event) {
            console.log("handlePaste", event);
            const stringFromClipboard = event.clipboardData.getData("text/plain");
            try {
                const board = JSON.parse(stringFromClipboard);
                const isValid = typeof _.get(board, "diagram") === "object";
                console.log("isValid", {
                    isValid,
                    board,
                });
                if (isValid) {
                    board.language = this.$i18n.locale;
                    this.createStoryFromDiagram(board)
                        .then((result) => {
                            if (!!result) {
                                this.$message.success({
                                    content: this.$t("chatbotv2.importSuccess"),
                                    duration: 2,
                                });
                                setTimeout(() => {
                                    this.$router.push(`/chatbot/story/${result.story._id}/${result.board.version}`);
                                }, 500);
                            } else {
                                this.$message.error({
                                    content: this.$t("chatbotv2.importFailed"),
                                    duration: 2,
                                });
                            }
                        })
                        .catch((err) => {
                            this.$message.error({
                                content: this.$t("chatbotv2.importFailed"),
                                duration: 2,
                            });
                        })
                        .finally(() => {
                            this.importing = false;
                        });
                }
            } catch (e) {}
        },
        handleSearch() {
            console.log("Searching for:", this.searchQuery);
        },
        togglePlatform(platform) {
            const index = this.selectedPlatforms.indexOf(platform);
            if (index > -1) {
                this.selectedPlatforms.splice(index, 1);
            } else {
                this.selectedPlatforms.push(platform);
            }
        },
        setupEventListeners() {
            const handleEscapeKey = (e) => {
                if (["Escape", "Esc"].includes(e.key)) {
                    this.resetSelectedStories();
                }
            };

            window.addEventListener("keydown", handleEscapeKey);
            this.cancels.push(() => window.removeEventListener("keydown", handleEscapeKey));
        },
    },
    mounted() {
        this.setupEventListeners();

        this.listStories().finally(() => {
            this.loading = false;
        });

        setTimeout(() => {
            log("story", this.stories);
            if (this.queryAction == "create") this.modalVisible = true;
        }, 1000);
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    watch: {
        selectedStories: {
            handler: function (val) {
                if (val.length === 0) {
                    this.multiDeleteMode = false;
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
#storyList {
    display: flex;
    width: 100%;
    height: 100%;

    .multi-delete-bar {
        align-items: center;
        background: #006cff;
        color: #fff;
        display: flex;
        flex-wrap: wrap;
        height: 50px;
        left: 0;
        padding: 0 30px;
        position: fixed;
        right: 0;
        z-index: 11;
        bottom: 20px;
        width: 50%;
        margin: auto;

        section.uncheck {
            align-items: center;
            cursor: pointer;
            display: flex;
            grid-area: uncheck;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }

            .material-icons {
                font-size: 15px;
                margin-right: 10px;
                margin-top: 2px;
            }
        }

        section.select {
            cursor: pointer;
            grid-area: select;
            margin-left: 20px;
            transition: all 0.3s;

            &:hover {
                opacity: 0.8 !important;
            }
        }

        section.queries {
            grid-area: queries;
            margin-left: auto;
        }

        section.actions {
            align-items: center;
            display: flex;
            grid-area: actions;
            justify-content: center;
            margin-left: 20px;

            div {
                align-items: center;
                border: 1px solid #fff;
                border-radius: 100%;
                cursor: pointer;
                display: flex;
                height: 26px;
                justify-content: center;
                margin: 0 5px;
                transition: opacity 0.3s;
                width: 26px;

                .material-icons {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
    }

    .content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        overflow: auto;
    }

    .big-title-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0 40px 0;

        .big-title {
            margin: 0;
            font-weight: bold;
            font-size: 1.5rem;
        }
    }

    .stories {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .delete-bg {
            opacity: 0.3 !important;
        }

        .selected {
            border: 1.5px solid #339bff !important;
        }

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            cursor: pointer;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            position: relative;
            text-decoration: none;
            color: inherit;
            display: block;

            .transparent-area {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(255, 255, 255, 0);
                z-index: 10;
            }

            .custom-checkbox-multi-delete {
                opacity: 0;
                position: absolute;
                width: 25px;
                height: 25px;
                z-index: 2;
                cursor: pointer;
            }

            .custom-label-multi-delete {
                display: inline-block;
                position: absolute;
                width: 25px;
                height: 25px;
                border-radius: 50%;
                border: 1px solid #e3e3e3;
                cursor: pointer;
                top: 20px;
                right: 20px;
                z-index: 1;
                background-color: transparent;
                transition: background-color 0.3s;
                text-align: center;
                line-height: 25px;
            }

            .custom-checkbox-multi-delete:checked + .custom-label-multi-delete {
                background-color: #339bff;
                border: 1px solid #339bff;
            }

            .custom-checkbox-multi-delete:checked + .custom-label-multi-delete::before {
                content: "✔";
                color: white;
                font-size: 16px;
                display: inline-block;
            }

            .graph-alignment {
                height: 100% !important;
                padding-bottom: 44px !important;
            }

            .ribbon {
                background: #79a70a;
                position: absolute;
                top: -34px;
                left: -7px;
                background: linear-gradient(#e0e0e0 10%, #f0f0f0 50%);
                z-index: 1;
                overflow: hidden;
                text-align: center;
                float: left;

                .integration-icons {
                    width: 20px;
                    height: 20px;
                }
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
                overflow-wrap: anywhere;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .story-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #22272d;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }

    .text-shorten {
        text-overflow: ellipsis;
        display: -webkit-box;
        max-width: 200px;
        height: 115px;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .echart-graph {
        height: 110px;
        margin-top: 5px;

        canvas {
            z-index: 3;
        }
    }

    .section-templates {
        max-width: 100%;
        margin-top: 15px;

        .section-templates-header {
            align-items: center;
            display: flex;
            justify-content: space-between;
            margin-bottom: 16px;
            width: 100%;

            .section-templates-header-text {
                align-items: center;
                display: flex;
                font-weight: 600;
                font-size: 24px;
                line-height: 31px;

                .material-icons {
                    color: #516173;
                    margin-bottom: 1px;
                    margin-right: 14px;
                }
            }
        }
    }
}

.search-and-filters {
    display: flex;
    align-items: center;
    gap: 1rem;

    .platform-filters {
        .platform-button {
            padding: 0.25rem;
            display: flex;
            justify-content: center;
            align-items: center;

            &.active {
                background-color: #1890ff;
                color: white;
            }
        }
    }
}
</style>

<style lang="scss">
.ant-popover.no-padding {
    .ant-popover-inner-content {
        padding: 0 !important;
    }
}

.story-menu-popover-items {
    .ant-popover-inner-content {
        padding: 8px !important;
    }

    &:hover {
        color: #06a9f3;
        cursor: pointer;
    }
}
</style>
